import React, { useState } from "react";

function Contact({
  onProceed,
  onBack,
  theme,
  total,
  contactFirstName,
  setContactFirstName,
  contactLastName,
  setContactLastName,
  contactBusinessName,
  setContactBusinessName,
  contactEmail,
  setContactEmail,
  contactPhone,
  setContactPhone,
}) {
  const [validationErrors, setValidationErrors] = useState({
    contactFirstName: false,
    contactLastName: false,
    contactEmail: false,
    contactPhone: false
  });
  
  const isNextButtonEnabled = () => {
    return contactFirstName && contactLastName && contactPhone && contactEmail;
  };

  const validateInput = (value, type) => {
    let regex;
    switch (type) {
      case "name":
        regex = /^[a-zA-Z\s'-]+$/; // Allows letters, spaces, apostrophes, and dashes
        break;
      case "email":
        regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation
        break;
      case "phone":
        regex = /^\d{10}$/; // Allows exactly 10 digits (US phone numbers)
        break;
      default:
        return true; // Allow all for other types
    }
    return regex.test(value);
  };

  const handleProceed = () => {
    // Validate all required fields
    const validationsRequired = {
      contactFirstName: !validateInput(contactFirstName, "name"),
      contactLastName: !validateInput(contactLastName, "name"),
      contactEmail: !validateInput(contactEmail, "email"),
      contactPhone: !validateInput(contactPhone, "phone")
    };

    setValidationErrors(validationsRequired);

    // Check if any validations failed
    if (Object.values(validationsRequired).includes(true)) {
      return; // Don't proceed if there are validation errors
    }

    // If all validations pass, call the original onProceed
    onProceed();
  };

  // const handleInputChange = (setter, value, type) => {
  //   if (validateInput(value, type)) {
  //     setter(value);
  //   } else {
  //     alert(`Invalid ${type} format.`);
  //   }
  // };

  const styles = {
    emptyFieldsMessage: {
      color: '#ff0000',
      fontSize: '12px',
      marginTop: '4px',
      marginBottom: '4px'
    },
    errorInput: {
      borderColor: '#ff0000',
      borderWidth: '2px',
      boxShadow: '0 0 5px rgba(255, 0, 0, 0.5)'
    },
    validationMessage: {
      color: '#ff0000',
      fontSize: '12px',
      marginTop: '4px',
      marginBottom: '0px'
    },
    title: {
      color: theme.primaryFontColor,
      fontSize: "20px",
      marginBottom: "20px",
    },
    button: {
      backgroundColor: theme.accentColor,
      color: "white",
      border: "none",
      padding: "10px 15px",
      borderRadius: "5px",
      cursor: "pointer",
      width: 150,
    },
    input: {
      display: "block",
      width: "90%",
      marginBottom: "7px",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "5px",
    },
    formRow: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
    footer: {
      position: "absolute",
      bottom: "0",
      left: "0",
      right: "0",
      padding: "10px 20px",
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "white",
      borderTop: "1px solid #ccc",
      borderBottomLeftRadius: "10px",
      borderBottomRightRadius: "10px",
    },
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <h3 style={styles.title}>Order Contact Info</h3>
      <div
        name="divider"
        style={{
          backgroundColor: theme.primaryFontColor,
          height: 1,
          marginBottom: 20,
        }}
      />
      <div
        name="scrollable-content"
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1, // Allow the scrollable content to take the remaining height
          overflowY: "auto", // Enable vertical scrolling
          padding: "10px",
          paddingBottom: 125,
          // backgroundColor: "red",
        }}
      >
        {/* <form onSubmit={onProceed} style={{}}> */}
        <div>
          <p
            style={{
              color: "black",
              width: "60%",
              fontSize: 14,
              textAlign: "center",
              margin: "0 auto",
              marginBottom: "20px",
              fontWeight: "600",
            }}
          >
            Please provide the contact information for the person that will
            receive the order.
          </p>

  

          <div
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              width: "100%",
              justifyContent: "center",
              // backgroundColor: "blue",
              overflowY: "auto",
              flex: 1,
              // height: "80%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              
              <div style={{ flex: "1" }}>
                <input
                  type="text"
                  value={contactFirstName}
                  onChange={(e) => setContactFirstName(e.target.value)}
                  placeholder="First Name (Required)"
                  required
                  style={{
                    ...styles.input,
                    flex: "1",
                    ...(validationErrors.contactFirstName ? styles.errorInput : {})
                  }}
                />
                {validationErrors.contactFirstName && (
                  <div style={styles.validationMessage}>Please enter a valid first name.</div>
                )}
              </div>

              <div style={{ flex: "1" }}>
                <input
                  type="text"
                  value={contactLastName}
                  onChange={(e) => setContactLastName(e.target.value)}
                  placeholder="Last Name (Required)"
                  required
                  style={{
                    ...styles.input,
                    flex: "1",
                    ...(validationErrors.contactLastName ? styles.errorInput : {})
                  }}
                />
                {validationErrors.contactLastName && (
                  <div style={styles.validationMessage}>Please enter a valid last name.</div>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <div style={{ flex: "1" }}>
                <input
                  type="email"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  placeholder="Email (Required)"
                  required
                  style={{
                    ...styles.input,
                    flex: "1",
                    ...(validationErrors.contactEmail ? styles.errorInput : {})
                  }}
                />
                {validationErrors.contactEmail && (
                  <div style={styles.validationMessage}>Please enter a valid email address (e.g. example@example.com).</div>
                )}
              </div>

              <div style={{ flex: "1" }}>
                <input
                  type="tel"
                  value={contactPhone}
                  onChange={(e) => setContactPhone(e.target.value)}
                  placeholder="Cell Phone (Required)"
                  required
                  style={{
                    ...styles.input,
                    flex: "1",
                    ...(validationErrors.contactPhone ? styles.errorInput : {})
                  }}
                />
                {validationErrors.contactPhone && (
                  <div style={styles.validationMessage}>Please enter a valid phone number (10 digits).</div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* </form> */}
      </div>

      <div style={styles.footer}>
        <div style={{ flex: 2, textAlign: "right" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              justifySelf: "flex-end",
            }}
          >
            <div
              style={{
                width: "35%",
              }}
            />
            <h4
              style={{
                color: "black",
                marginBottom: "10px",
                fontWeight: "400",
              }}
            >
              Order Total:
            </h4>
            <h4
              style={{
                color: theme.primaryFontColor,
                marginBottom: "10px",
                textAlign: "right",
              }}
            >
              ${total.toFixed(2)}
            </h4>
          </div>
          <div
            style={{
              // backgroundColor: "red",
              // width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
            }}
          >
            <button
              style={{ ...styles.button, opacity: 1, pointerEvents: "auto" }}
              onClick={onBack}
            >
              Back
            </button>

            <button
              style={styles.button}
              onClick={handleProceed}
              disabled={!isNextButtonEnabled()}
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {/* </form> */}
    </div>
  );
}

export default Contact;
